import React, { useState, useEffect, useContext } from 'react'

import api from '../../api'
import { QueueSocket } from '../../routes'
import { Box } from '@mui/material'
import './style.css'
import { getSession } from '../../auth'
import AutorenewIcon from '@mui/icons-material/Autorenew';
import useNotification from '../Notification'

let timeout = null

const getSafeTotalSteps = (newcache) => Number(newcache?.totalSteps || 1)
const getSafeStep = (newcache) => Number(newcache?.step || 0)
const getProgressPercentage = (newcache) => Math.round(getSafeStep(newcache) / getSafeTotalSteps(newcache) * 100)
const getProgressCounter = (newcache) => newcache?.type === 'enterprises'
    ? `${getSafeStep(newcache)}/${getSafeTotalSteps(newcache)} `
    : `${newcache.status}/7 `
const getProgressTitle = (newcache) => newcache?.type === 'enterprises'
    ? `Registros ${getSafeStep(newcache)} de ${getSafeTotalSteps(newcache)}`
    : `Etapa ${newcache.status} de 7`
const UploadLoaderComponent = () => {
    const { cache, setCache, setFailedContacts } = useContext(QueueSocket)
    const [loadingContent, setLoadingContent] = useState()
    const user = getSession()
    const [retracted, setRetracted] = useState(true)
    const [errorCount, setErrorCount] = useState(0)

    const checkForAvailableCache = () => {
        if (!user)
            return false
        const getMemoryCache = localStorage.getItem('uploadCache');
        let newCache = cache ? cache : getMemoryCache
        return newCache
    }

    useEffect(() => {
        clearTimeout(timeout)
        checkCache()
    }, [cache])

    const checkCache = async () => {
        if (!user)
            return

        let newCache = checkForAvailableCache()

        if (newCache) {
            const res = await api.get(`/api/enterprises/${user.profile.enterprise.id}/contacts/progress/${newCache}/`)

            if (res.status === 200) {
                localStorage.setItem('uploadCache', newCache);
                setLoadingContent(res.data)
                if (res.data?.status >= 7) {
                    localStorage.removeItem('uploadCache');
                    setLoadingContent(null)
                    setCache(-1)
                    if (res.data.status === 7) {
                        const failed = res.data.failed_contacts || []
                        if (failed.length > 0) {
                            setFailedContacts(failed)
                            useNotification(
                                'Atenção!',
                                `${failed.length} contato(s) não puderam ser salvos. Revise-os na tabela de importação.`,
                                'warning'
                            );
                        } else {
                            useNotification(
                                'Sucesso!',
                                res.data.type === 'enterprises' ? 'Empresas importadas com sucesso.' : 'Clientes importados com sucesso.',
                                'success'
                            );
                        }
                    }
                    return
                }

                timeout = setTimeout(checkCache, 1000)
                return
            } else if (res.status === 400) {
                useNotification(
                    'Ops!',
                    res.data.detail,
                    'danger'
                );
            }
        }
        localStorage.removeItem('uploadCache');
        setLoadingContent(null)
    }

    const loadSimplifiedData = () => {
        if (!loadingContent)
            return

        const newcache = loadingContent
        const percentage = getProgressPercentage(newcache)

        return (
            <Box className={'flexrow'}>
                <AutorenewIcon className={'spinner'} />
                <span>Carregando:</span>
                <span>{getProgressCounter(newcache)}{percentage != 0 ? `${percentage}%` : null}</span>
            </Box>
        )

    }

    const loadingMessage = () => {
        if (!loadingContent)
            return

        const newcache = loadingContent
        const percentage = getProgressPercentage(newcache)
        let message = ''
        const isEnterpriseImport = newcache.type === 'enterprises'

        switch (newcache.status) {
            case 0:
                message = 'Iniciando'
                break
            case 1:
                message = `Lendo ${isEnterpriseImport ? 'empresas' : 'contatos'} ${percentage}%.`
                break
            case 2:
                message = `Atualizando ${isEnterpriseImport ? 'empresas' : 'contatos'} ${percentage}%.`
                break
            case 3:
                message = `Salvando ${isEnterpriseImport ? 'empresas' : 'contatos'} atualizados ${percentage}%.`
                break
            case 4:
                message = `${isEnterpriseImport ? 'Criando novas empresas' : 'Criando novos contatos'} ${percentage}%.`
                break
            case 5:
                message = `${isEnterpriseImport ? 'Salvando novos registros de empresas' : 'Salvando novos contatos'} ${percentage}%.`
                break
            case 6:
                message = `Criando novos segmentos ${percentage}%.`
                break
            case 7:
                message = 'Finalizado.'
                break
        }
        return (
            <>
                <Box className={'flexcolumn'}>
                    <span>{getProgressTitle(newcache)}</span>
                    <Box className={'flexrow'}>
                        <AutorenewIcon className={'spinner'} />
                        <span>{message}</span>
                    </Box>
                </Box>
            </>
        )

    }

    return (
        <>
            {checkForAvailableCache() &&
                <>
                    {
                        retracted ?
                            <Box className='sideuploader retracted' onClick={() => setRetracted(false)}>{loadSimplifiedData()}</Box>
                            :
                            <Box className='sideuploader' onClick={() => setRetracted(true)}>{loadingMessage()}</Box>
                    }
                </>
            }


        </>
    )
}

export default UploadLoaderComponent